import {useStyles} from '@wix/tpa-settings/react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Tooltip} from 'wix-ui-tpa'
import {useSettings} from '../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import stylesParams from '../../../../stylesParams'
import {getAlignmentClassName} from '../../../selectors/classes'
import s from './button-layout-empty-state.scss'

export const ButtonLayoutEmptyState = () => {
  const {t} = useTranslation()
  const {isMobile: mobile} = useEnvironment()
  const {get: getSetting} = useSettings()
  const {get: getStyle} = useStyles()
  const alignment = getStyle(stylesParams.alignment)

  const showRSVPTitle = getStyle(stylesParams.showRSVPTitle)
  const title = getSetting(settingsParams.RSVPTitle) as string

  const width = mobile ? undefined : getStyle(stylesParams.oneButtonWidth)
  const height = mobile ? undefined : getStyle(stylesParams.buttonHeight)

  const style = {
    minWidth: width,
    minHeight: height,
  }

  return (
    <div
      data-hook={DH.rsvpButton}
      className={classNames(s.container, s[getAlignmentClassName(alignment)], {
        [s.mobile]: mobile,
      })}
    >
      {showRSVPTitle && (
        <div className={s.title} data-hook="ev-rsvp-button-title">
          {title}
        </div>
      )}
      <Tooltip content={t('widgetEmptyStateNotification')}>
        <button className={s.button} style={style} data-hook="ev-rsvp-button">
          {getSetting(settingsParams.registrationClosedButtonText) as string}
        </button>
      </Tooltip>
    </div>
  )
}
